var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'img-loader',
    _vm.computedSize,
    { active: _vm.active === true },
    { fallback: _vm.fallback === true }
  ]},[_c('img',{ref:"img"}),_c('div',{staticClass:"fallback"},[_c('span',[_vm._v(" "+_vm._s(_vm.initial)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }